import createCache from '@emotion/cache';

import { isNotPrerenderUserAgent } from 'app/selectors';

export const emotionCache = createCache({
  key: 's',
  prefix: false,
  // https://stackoverflow.com/questions/73954622/prerender-io-does-not-cache-my-sites-css
  speedy: isNotPrerenderUserAgent(),
});
